import { fromJS } from 'immutable'
import { returnStateIfNoAction } from "../helpers";
import actionTypes from '../../actions/actionTypes'
import { addItemToArray, removeItemfromArray } from '../../functions/lists';

const { PROGRAM_UPDATE_DEFAULT } = require("../../constants/state");

const INIT_STATE = fromJS(PROGRAM_UPDATE_DEFAULT)


const updateItem = (state, action) => {
    const { payload } = action
    const pk = payload.pk
    const objectType = payload.objectType
    const ids = state.getIn([objectType, 'update'])
    const newIds = addItemToArray(ids, pk) 
    
    return state.setIn([objectType, 'update'], newIds)
}


const deleteItem = (state, action) => {
    const { payload } = action
    const pk = payload.pk
    const objectType = payload.objectType
    const idsUpdate = state.getIn([objectType, 'update'])
    const idsDelete = state.getIn([objectType, 'delete'])
    const newIdsUpdate = removeItemfromArray(idsUpdate, pk)
    const newIdsDelete = addItemToArray(idsDelete, pk) 

    return state.setIn([objectType, 'update'], newIdsUpdate)
                .setIn([objectType, 'delete'], newIdsDelete)
}

const changeItemLocal = (state, action, key) => {
    const { payload } = action
    const objectType = payload.objectType
    const items = state.getIn([objectType, key])

    return state.setIn([objectType, key], items.push(fromJS(payload.data)))
}

const resetItem = () => {
    return INIT_STATE
}

const updateProgramReducer = (state = INIT_STATE, action) => {

    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.PROGRAM_UPDATE_ITEM_UPDATE:
            return updateItem(state, action)
        case actionTypes.PROGRAM_UPDATE_ITEM_DELETE:
            return deleteItem(state, action)
        case actionTypes.PROGRAM_UPDATE_ITEM_LOCAL_UPDATE:
            return changeItemLocal(state, action, 'update')
        case actionTypes.PROGRAM_UPDATE_ITEM_LOCAL_DELETE:
            return changeItemLocal(state, action, 'delete')
        case actionTypes.PROGRAM_UPDATE_RESET:
            return resetItem()
        default:
            return state;
    }
}

export default updateProgramReducer;